function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.654 5.654)",
  id: "portraitLogo_svg__layer2",
  display: "inline"
}, /*#__PURE__*/React.createElement("circle", {
  r: 906.53,
  transform: "translate(181.386 1015.94) scale(.5416)",
  cy: -952.024,
  cx: 588.88,
  id: "portraitLogo_svg__path918",
  display: "inline",
  opacity: 1,
  fill: "#fd6881",
  fillOpacity: 1,
  stroke: "#f4f4f4",
  strokeWidth: 36.928,
  strokeLinecap: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.654 5.654)",
  id: "portraitLogo_svg__layer1",
  display: "inline"
}, /*#__PURE__*/React.createElement("path", {
  d: "M742.794 888.754s-6.385-115.811-10.187-159.48c-4.87-55.97-17.721-61.563-36.675-74.47-32.405-22.06-110.768-44.58-110.768-44.58H455.832s-71.278 11.758-103.68 33.82l-52.75 47.113-16.65-80.965-36.738 2.45-29.943 19.992-11.54 11.41s23.25 132.988 28.988 142.57c6.548 10.94 12.241 23.701 32.46 22.161 25.377-1.931 96.797-46.933 96.797-46.933l12.39 126.912h367.628",
  id: "portraitLogo_svg__path14",
  fill: "#3e3d54",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M534.368 831.87c-68.641-3.705-133.471-18.04-172-45.999 1.068.347 15.056 102.883 15.056 102.883h364.244s-3.786-82.306-6.96-123.593c-43.921 39.267-116.53 71.225-200.34 66.708",
  id: "portraitLogo_svg__path16",
  fill: "#3e3d54",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.191 572.66s-.317 20.814 6.523 29.45l-36.082 42.382-38.346-42.382c6.838-8.636 6.52-29.45 6.52-29.45h61.385",
  id: "portraitLogo_svg__path18",
  fill: "#fcd0b4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.87 579.356h56.54l3.702 17.253s-30.316 24.305-71.116 15.35l10.874-32.603",
  id: "portraitLogo_svg__path20",
  fill: "#e59686",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.278 652.936l57.862-12.954 34.432 7.218 24.5 5.736-57.218 184.273-59.576-184.273",
  id: "portraitLogo_svg__path22",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.427 765.335l11.552-80.857-19.179-39.184 27.599-5.312 26.11 5.312-19.17 39.184 14.047 83.905-20.987 60.59-19.972-63.638",
  id: "portraitLogo_svg__path24",
  fill: "#ffce64",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.089 766.352l11.89-81.874-19.179-39.184 27.599-5.312 26.11 5.312-19.17 39.184 13.031 81.197",
  id: "portraitLogo_svg__path26",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 4.062,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.98 684.478s6.028-6.233 15.358 0",
  id: "portraitLogo_svg__path28",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 4.062,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.84 615.646l43.152 31.912-38.81 14.293 35.978 31.038L508.314 877.04",
  id: "portraitLogo_svg__path30",
  fill: "none",
  stroke: "#656263",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.594 613.943l-42.185 33.615 38.81 14.293-35.976 31.038L515.54 845.447",
  id: "portraitLogo_svg__path32",
  fill: "none",
  stroke: "#656263",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.318 748.767s-14.583 37.26-27.218 56.217",
  id: "portraitLogo_svg__path34",
  fill: "none",
  stroke: "#656263",
  strokeWidth: 5.416,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M489.806 572.66s.318 20.814-6.52 29.45",
  id: "portraitLogo_svg__path38",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M467.472 606.13s-82.622 18.744-113.159 38.362c-14.333 9.214-54.91 50.775-54.91 50.775",
  id: "portraitLogo_svg__path40",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.14 642.12c-29.432-27.924-37.563-50.434-33.59-61.716 0 0-10.493 6.093-17.94 23.13-15.486 35.424 1.506 66.58 3.146 76.26 0 0 31.381-38.395 48.384-37.673",
  id: "portraitLogo_svg__path42",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.14 642.12c-29.432-27.924-37.563-50.434-33.59-61.716 0 0-10.493 6.093-17.94 23.13-15.486 35.424 1.506 66.58 3.146 76.26 0 0 31.381-38.395 48.384-37.673z",
  id: "portraitLogo_svg__path44",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 5.416,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.55 580.404s-10.493 6.093-17.94 23.13c-15.486 35.424 1.506 66.58 3.146 76.26l49.643 149.179",
  id: "portraitLogo_svg__path46",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.528 606.13s89.999 26.614 122.404 48.674c18.954 12.907 31.806 18.5 36.675 74.47 3.802 43.669 10.187 159.48 10.187 159.48",
  id: "portraitLogo_svg__path48",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.246 722.955c1.354 6.319 16.925 165.8 16.925 165.8",
  id: "portraitLogo_svg__path50",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.758 722.955c-1.354 6.319-19.866 165.8-19.866 165.8",
  id: "portraitLogo_svg__path52",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.86 642.12c29.432-27.924 37.563-50.434 33.592-61.716 0 0 10.493 6.093 17.94 23.13 15.487 35.424-1.508 66.58-3.148 76.26 0 0-31.379-38.395-48.385-37.673",
  id: "portraitLogo_svg__path54",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.86 642.12c29.432-27.924 37.563-50.434 33.592-61.716 0 0 10.493 6.093 17.94 23.13 15.487 35.424-1.508 66.58-3.148 76.26 0 0-31.379-38.395-48.385-37.673z",
  id: "portraitLogo_svg__path56",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 5.416,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M554.452 580.404s10.493 6.093 17.94 23.13c15.487 35.424.364 64.778-3.148 76.26L505.902 881.16",
  id: "portraitLogo_svg__path58",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.985 873.85c0 4.04-3.28 7.311-7.314 7.311a7.315 7.315 0 01-7.316-7.311c0-4.041 3.28-7.312 7.316-7.312a7.314 7.314 0 017.314 7.312",
  id: "portraitLogo_svg__path60",
  fill: "#e0e6e8",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.985 873.85c0 4.04-3.28 7.311-7.314 7.311a7.315 7.315 0 01-7.316-7.311c0-4.041 3.28-7.312 7.316-7.312a7.314 7.314 0 017.314 7.312z",
  id: "portraitLogo_svg__path62",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 5.416,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.506 610.192c11.964-4.02 12.962 4.094 12.962 4.094s20.048 121.272 19.729 119.803",
  id: "portraitLogo_svg__path64",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.65 629.486s-19.558 9.146-18.198 20.429c-.148 1.153 23.435 118.566 28.519 132.779 9.865 27.577 27.397 29.098 43.486 24.111 34.563-10.72 86.927-44.087 86.927-44.087",
  id: "portraitLogo_svg__path66",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.34 655.942l-4.254-41.487s-31.542-10.706-37.69-52.711c0 0-15.963-22.87-16.676-32.183-.8-10.335 11.323-19.115 21.76-16.005 0 0 6.562-19.512 24.429-17.115 0 0 8.712-15.99 26.234-9.59 0 0-3.495-56.175-3.3-74.22.196-18.047 20.902-17.635 23.398-3.71 1.843 10.278 18.127 117.64 18.127 117.64l.196 1.682c9.684 5.644 13.72 11.875 10.904 29.36-2.771 17.141-15.304 38.308-15.304 38.308l2.708 39.061-26.858 15.1-23.674 5.87",
  id: "portraitLogo_svg__path68",
  fill: "#fcd0b4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.931 564.991s8.636 8.6 16.394 5.91c7.754-2.694 10.083-10.363 10.083-10.363s8.727 1.582 13.549-2.02c4.823-3.608 11.62-12.741 11.62-12.741l8.298 6.732s-18.046 19.379-18.308 28.387c0 0-33.307.36-37.394 1.179-4.096.831-4.242-17.084-4.242-17.084",
  id: "portraitLogo_svg__path70",
  fill: "#da907b",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.34 655.942l-4.254-41.487s-31.542-10.706-37.69-52.711c0 0-15.963-22.87-16.676-32.183-.8-10.335 11.323-19.115 21.76-16.005 0 0 6.562-19.512 24.429-17.115 0 0 8.712-15.99 26.234-9.59 0 0-3.495-56.175-3.3-74.22.196-18.047 20.902-17.635 23.398-3.71 1.843 10.278 18.127 117.64 18.127 117.64l.196 1.682c9.684 5.644 13.72 11.875 10.904 29.36-2.771 17.141-15.304 38.308-15.304 38.308l2.708 39.061",
  id: "portraitLogo_svg__path72",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.564 528.243c-18.814-10.96-47.262-14.704-50.184-3.914-2.917 10.79 16.163 26.462 28.212 30.154",
  id: "portraitLogo_svg__path74",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.807 551.726s-24.283 22.04-18.304 42.281",
  id: "portraitLogo_svg__path76",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.143 486.85l9.245 30.445",
  id: "portraitLogo_svg__path78",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.926 496.23l14.107 28.173",
  id: "portraitLogo_svg__path80",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.08 561.496s9.223 8.88 15.466 9.567c8.632.952 14.799-3.431 14.83-11.678 0 0 14.493 5.242 23.911-11.132",
  id: "portraitLogo_svg__path82",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.48 513.556s14.242 37.345 26.483 45.511",
  id: "portraitLogo_svg__path84",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.452 649.915s3.73 7.447 23.028 5.615c24.08-2.285 57.33-23.647 58.988-36.558",
  id: "portraitLogo_svg__path86",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.153 850.085c1.185 4.44-2.433 9.304-8.103 10.864-5.659 1.548-11.213-.802-12.404-5.25-1.188-4.434 2.44-9.293 8.099-10.842 5.66-1.549 11.217.802 12.408 5.228",
  id: "portraitLogo_svg__path88",
  fill: "#c4c4c4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.153 850.085c1.185 4.44-2.433 9.304-8.103 10.864-5.659 1.548-11.213-.802-12.404-5.25-1.188-4.434 2.44-9.293 8.099-10.842 5.66-1.549 11.217.802 12.408 5.228z",
  id: "portraitLogo_svg__path90",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 4.062,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.462 844.381c1.19 4.447 6.744 6.774 12.404 5.226 5.66-1.553 9.287-6.396 8.092-10.843-1.185-4.434-6.738-6.785-12.402-5.225-5.655 1.542-9.283 6.406-8.094 10.842",
  id: "portraitLogo_svg__path92",
  fill: "#c4c4c4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.462 844.381c1.19 4.447 6.744 6.774 12.404 5.226 5.66-1.553 9.287-6.396 8.092-10.843-1.185-4.434-6.738-6.785-12.402-5.225-5.655 1.542-9.283 6.406-8.094 10.842z",
  id: "portraitLogo_svg__path94",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 4.062,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.744 353.858s-33.537-131.516 39.002-183.266c0 0 11.234-24.372 62.364-53.3 65.686-37.153 156.578-21.896 170.51 23.22 0 0 38.658 6.309 64.357 43.127 24.55 35.16 35.16 69.644 23.003 169.166l.173 46.088-351.151 26.526-8.258-71.561",
  id: "portraitLogo_svg__path108",
  fill: "#3e3d54",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M380.746 186.704s11.234-24.372 62.364-53.293c65.686-37.16 156.578-21.897 170.51 23.218 0 0 38.658 6.31 64.357 43.128 16.65 23.841 26.873 47.4 27.945 91.108 1.23-54.35-9.36-80.606-27.945-107.226-25.699-36.818-64.358-43.128-64.358-43.128-13.931-45.115-104.823-60.372-170.509-23.218-51.13 28.927-62.364 53.299-62.364 53.299-40.332 28.775-47.853 82.204-46.601 123.978 1.146-38.611 11.301-82.676 46.6-107.866",
  id: "portraitLogo_svg__path110",
  fill: "#c4c4c4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.98 368.921l.11 29.979.063-.007-.116-30.48c-.021.169-.036.339-.057.508",
  id: "portraitLogo_svg__path112",
  fill: "#644a3f",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.346 370.734s32.687-26.207 44.965 14.89c14.104 47.215-33.17 98.688-54.623 102.714",
  id: "portraitLogo_svg__path114",
  fill: "#fcd0b4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.346 370.734s32.687-26.207 44.965 14.89c14.104 47.215-33.17 98.688-54.623 102.714",
  id: "portraitLogo_svg__path116",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M701.86 431.326c-6.721 15.291-19.455 24.467-28.449 20.517-8.995-3.952-10.836-19.555-4.109-34.844 6.728-15.281 19.464-24.463 28.456-20.507 8.993 3.952 10.823 19.555 4.102 34.834",
  id: "portraitLogo_svg__path118",
  fill: "#e59686",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M711.149 385s-17.358-7.633-30.803 21.996",
  id: "portraitLogo_svg__path120",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.692 370.734s-32.689-26.207-44.968 14.89c-14.102 47.215 33.173 98.688 54.626 102.714",
  id: "portraitLogo_svg__path122",
  fill: "#fcd0b4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.692 370.734s-32.689-26.207-44.968 14.89c-14.102 47.215 33.173 98.688 54.626 102.714",
  id: "portraitLogo_svg__path124",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.722 430.444c6.721 15.279 19.46 24.467 28.448 20.515 8.994-3.957 10.832-19.549 4.105-34.838-6.717-15.281-19.462-24.467-28.449-20.507-8.991 3.952-10.821 19.538-4.104 34.83",
  id: "portraitLogo_svg__path126",
  fill: "#e59686",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.882 385s17.365-7.633 30.81 21.996",
  id: "portraitLogo_svg__path128",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M652.85 219.51c40.55 108.666 34.975 254.072-6.274 309.226-31.846 42.581-74.75 66.985-126.055 66.985-51.31 0-94.215-24.404-126.06-66.985-43.29-57.88-46.888-218.086.445-326.271l.899-1.148c40.27-27.86 101.709-29.702 101.709-29.702s-38.209 18.518-32.697 24.567c5.722 6.283 42.333 9.403 76.046-.233 48.655-13.902 60.813-33.78 60.813-33.78s3.083 41.027 52.743 58.017",
  id: "portraitLogo_svg__path130",
  fill: "#fcd0b4",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M652.85 219.51c40.55 108.666 34.975 254.072-6.274 309.226-31.846 42.581-74.75 66.985-126.055 66.985-51.31 0-94.215-24.404-126.06-66.985-43.29-57.88-46.888-218.086.445-326.271l.899-1.148c40.27-27.86 101.709-29.702 101.709-29.702s-38.209 18.518-32.697 24.567c5.722 6.283 42.333 9.403 76.046-.233 48.655-13.902 60.813-33.78 60.813-33.78s3.083 41.027 52.743 58.017",
  id: "portraitLogo_svg__path132",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M361.506 362.426h34.707",
  id: "portraitLogo_svg__path134",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.742 398.889c0 7.828-12.504 14.175-27.93 14.175s-27.95-6.347-27.95-14.175 12.524-14.16 27.95-14.16 27.93 6.332 27.93 14.16",
  id: "portraitLogo_svg__path136",
  fill: "#f6807f",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M668.784 398.889c0 7.828-12.507 14.175-27.937 14.175-15.422 0-27.94-6.347-27.94-14.175s12.518-14.16 27.94-14.16c15.43 0 27.937 6.332 27.937 14.16",
  id: "portraitLogo_svg__path138",
  fill: "#f6807f",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.955 359.21c0 19.824-12.662 35.886-28.275 35.886-15.613 0-28.265-16.062-28.265-35.885 0-19.824 12.652-35.893 28.265-35.893 15.613 0 28.275 16.069 28.275 35.893",
  id: "portraitLogo_svg__path140",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M469.926 361.03c0 10.667-6.594 19.337-14.736 19.337-8.14 0-14.745-8.67-14.745-19.337 0-10.681 6.605-19.325 14.745-19.325 8.142 0 14.736 8.644 14.736 19.325",
  id: "portraitLogo_svg__path142",
  fill: "#231f20",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.812 352.514s3.004-21.896 23.458-27.983c23.932-7.117 30.068 17.039 30.068 17.039s-12.461-9.267-27.313-5.481c-13.995 3.569-26.213 16.425-26.213 16.425",
  id: "portraitLogo_svg__path144",
  fill: "#deedfa",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.338 341.57s-6.136-24.156-30.068-17.04c-20.454 6.088-23.458 27.984-23.458 27.984",
  id: "portraitLogo_svg__path146",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M470.26 350.739c0 2.516-2.023 4.558-4.512 4.558-2.49 0-4.513-2.042-4.513-4.558 0-2.513 2.022-4.555 4.513-4.555 2.49 0 4.512 2.042 4.512 4.555",
  id: "portraitLogo_svg__path148",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.087 359.21c0 19.824 12.651 35.886 28.265 35.886 15.62 0 28.268-16.062 28.268-35.885 0-19.824-12.649-35.893-28.268-35.893-15.614 0-28.265 16.069-28.265 35.893",
  id: "portraitLogo_svg__path150",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.106 361.03c0 10.667 6.6 19.337 14.735 19.337 8.145 0 14.746-8.67 14.746-19.337 0-10.681-6.6-19.325-14.746-19.325-8.135 0-14.735 8.644-14.735 19.325",
  id: "portraitLogo_svg__path152",
  fill: "#231f20",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.226 352.514s-3.01-21.896-23.458-27.983c-23.939-7.117-30.074 17.039-30.074 17.039s12.461-9.267 27.312-5.481c14.002 3.569 26.22 16.425 26.22 16.425",
  id: "portraitLogo_svg__path154",
  fill: "#deedfa",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M568.694 341.57s6.135-24.156 30.074-17.04c20.447 6.088 23.458 27.984 23.458 27.984",
  id: "portraitLogo_svg__path156",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.347 350.739c0 2.516 2.021 4.558 4.517 4.558 2.486 0 4.506-2.042 4.506-4.558 0-2.513-2.02-4.555-4.506-4.555-2.496 0-4.517 2.042-4.517 4.555",
  id: "portraitLogo_svg__path158",
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.728 359.162s17.37-4.902 30.292 1.868",
  id: "portraitLogo_svg__path160",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M340.866 359.236s-32.659-136.894 39.88-188.644c0 0 11.234-24.372 62.364-53.3 65.686-37.153 156.578-21.896 170.51 23.22 0 0 38.658 6.309 64.357 43.127 24.55 35.16 35.16 79.084 23.003 178.6",
  id: "portraitLogo_svg__path162",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.997 285.736c-2.328-5.421-7.62-11.71-14.768-16.551-7.097-4.907-16.046-8.422-24.763-9.576-8.716-1.235-16.999.005-22.468 1.847-11.174 3.596-18.966 11.265-22.753 17.31-3.882 6.152-4.496 10.74-2.952 11.742 3.403 2.296 13.699-10.627 30.006-15.848 4.046-1.36 10.054-2.643 16.951-2.318 6.87.271 14.502 2.194 21.04 5.313 6.569 3.071 11.928 7.28 15.116 10.924 2.39 2.838 5.702 1.338 4.59-2.843",
  id: "portraitLogo_svg__path164",
  fill: "#291d16",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.997 285.736c-2.328-5.421-7.62-11.71-14.768-16.551-7.097-4.907-16.046-8.422-24.763-9.576-8.716-1.235-16.999.005-22.468 1.847-11.174 3.596-18.966 11.265-22.753 17.31-3.882 6.152-4.496 10.74-2.952 11.742 3.403 2.296 13.699-10.627 30.006-15.848 4.046-1.36 10.054-2.643 16.951-2.318 6.87.271 14.502 2.194 21.04 5.313 6.569 3.071 11.928 7.28 15.116 10.924 2.39 2.838 5.702 1.338 4.59-2.843z",
  id: "portraitLogo_svg__path166",
  fill: "none",
  stroke: "#291d16",
  strokeWidth: 4.062,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M548.041 285.736c2.327-5.421 7.62-11.71 14.761-16.551 7.098-4.907 16.047-8.422 24.763-9.576 8.723-1.235 17 .005 22.475 1.847 11.174 3.596 18.96 11.265 22.747 17.31 3.886 6.152 4.495 10.74 2.951 11.742-3.396 2.296-13.698-10.627-30-15.848-4.05-1.36-10.053-2.643-16.952-2.318-6.87.271-14.496 2.194-21.038 5.313-6.575 3.071-11.928 7.28-15.118 10.924-2.395 2.838-5.706 1.338-4.589-2.843",
  id: "portraitLogo_svg__path168",
  fill: "#291d16",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M548.041 285.736c2.327-5.421 7.62-11.71 14.761-16.551 7.098-4.907 16.047-8.422 24.763-9.576 8.723-1.235 17 .005 22.475 1.847 11.174 3.596 18.96 11.265 22.747 17.31 3.886 6.152 4.495 10.74 2.951 11.742-3.396 2.296-13.698-10.627-30-15.848-4.05-1.36-10.053-2.643-16.952-2.318-6.87.271-14.496 2.194-21.038 5.313-6.575 3.071-11.928 7.28-15.118 10.924-2.395 2.838-5.706 1.338-4.589-2.843z",
  id: "portraitLogo_svg__path170",
  fill: "none",
  stroke: "#291d16",
  strokeWidth: 4.062,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M511.075 383.386s4.03 15.28 1.343 31.015",
  id: "portraitLogo_svg__path172",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.4 405.705s-16.227 20.285-16.635 27.584c-.407 7.3 13.334 19.468 13.334 19.468",
  id: "portraitLogo_svg__path174",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M505.14 362.769c0 30.08-24.382 54.456-54.466 54.456-30.074 0-54.46-24.376-54.46-54.456 0-30.082 24.386-54.464 54.46-54.464 30.084 0 54.467 24.382 54.467 54.464z",
  id: "portraitLogo_svg__path176",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 8.666,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M679.532 362.426h-34.707",
  id: "portraitLogo_svg__path178",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 7.582,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.902 362.769c0 30.08 24.382 54.456 54.456 54.456 30.084 0 54.467-24.376 54.467-54.456 0-30.082-24.383-54.464-54.467-54.464-30.074 0-54.456 24.382-54.456 54.464z",
  id: "portraitLogo_svg__path180",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 8.666,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.507 480.889c40.18 0 60.865-7.953 60.865-7.953.35 18.882-5.287 94.065-58.851 94.065-53.561 0-59.206-75.183-58.853-94.065 0 0 16.674 7.953 56.84 7.953",
  id: "portraitLogo_svg__path182",
  fill: "#eb4b7c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M521.215 494.086c20.615 0 39.563 6.632 54.816 16.434 2.881-14.191 3.453-31.2 3.34-37.584 0 0-20.684 7.953-60.864 7.953-40.165 0-56.839-7.953-56.839-7.953-.124 6.514.472 23.865 3.502 38.371 14.64-10.984 34.878-17.221 56.045-17.221",
  id: "portraitLogo_svg__path184",
  fill: "#c2434f",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 0.542
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.507 480.889c40.18 0 60.865-7.953 60.865-7.953.35 18.882-5.287 94.065-58.851 94.065-53.561 0-59.206-75.183-58.853-94.065 0 0 16.674 7.953 56.84 7.953z",
  id: "portraitLogo_svg__path186",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 6.499,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}));

function SvgPortraitLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1011.955 1011.955",
    height: 1011.955,
    width: 1011.955,
    xmlSpace: "preserve",
    id: "portraitLogo_svg__svg2"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/portraitLogo.52007c8d.svg";
export { SvgPortraitLogo as ReactComponent };